// src/state/settings/selectedMode/types.ts
var CoursingModes = /* @__PURE__ */ ((CoursingModes2) => {
  CoursingModes2["PREDEFINED"] = "predefined";
  CoursingModes2["ON_THE_FLY"] = "on_the_fly";
  return CoursingModes2;
})(CoursingModes || {});
var RegisterSeatingModes = /* @__PURE__ */ ((RegisterSeatingModes2) => {
  RegisterSeatingModes2["PROMPT"] = "prompt";
  RegisterSeatingModes2["NO_PROMPT"] = "no_prompt";
  RegisterSeatingModes2["HYBRID"] = "hybrid";
  return RegisterSeatingModes2;
})(RegisterSeatingModes || {});
var KitchenCustomizingReceiptsStatus = /* @__PURE__ */ ((KitchenCustomizingReceiptsStatus2) => {
  KitchenCustomizingReceiptsStatus2["ACTIVE"] = "active";
  KitchenCustomizingReceiptsStatus2["INACTIVE"] = "inactive";
  return KitchenCustomizingReceiptsStatus2;
})(KitchenCustomizingReceiptsStatus || {});
var EPinPadLayouts = /* @__PURE__ */ ((EPinPadLayouts2) => {
  EPinPadLayouts2["TELEPHONE"] = "telephone";
  EPinPadLayouts2["CALCULATOR"] = "calculator";
  return EPinPadLayouts2;
})(EPinPadLayouts || {});
var TipPayoutMethods = /* @__PURE__ */ ((TipPayoutMethods2) => {
  TipPayoutMethods2["MANUAL"] = "manual";
  TipPayoutMethods2["PAYROLL"] = "payroll";
  return TipPayoutMethods2;
})(TipPayoutMethods || {});
var DefaultTipInput = /* @__PURE__ */ ((DefaultTipInput2) => {
  DefaultTipInput2["NEW_TOTAL"] = "newTotal";
  DefaultTipInput2["TIP_AMOUNT"] = "tipAmount";
  return DefaultTipInput2;
})(DefaultTipInput || {});
var TipDistribution = /* @__PURE__ */ ((TipDistribution2) => {
  TipDistribution2["INDIVIDUAL"] = "individual";
  TipDistribution2["POOLING"] = "pooling";
  TipDistribution2["SHARING"] = "sharing";
  return TipDistribution2;
})(TipDistribution || {});
var SplitTipInterval = /* @__PURE__ */ ((SplitTipInterval2) => {
  SplitTipInterval2["SHIFT"] = "shift";
  SplitTipInterval2["DAY"] = "day";
  return SplitTipInterval2;
})(SplitTipInterval || {});
var TipShareBy = /* @__PURE__ */ ((TipShareBy2) => {
  TipShareBy2["ROLE"] = "role";
  TipShareBy2["MENU_TYPE"] = "menuType";
  TipShareBy2["CATEGORY"] = "category";
  TipShareBy2["SUBCATEGORY"] = "subcategory";
  TipShareBy2["ITEM"] = "item";
  return TipShareBy2;
})(TipShareBy || {});
var ServiceChargeAssignTo = /* @__PURE__ */ ((ServiceChargeAssignTo2) => {
  ServiceChargeAssignTo2["SERVER"] = "server";
  ServiceChargeAssignTo2["RESTAURANT"] = "restaurant";
  return ServiceChargeAssignTo2;
})(ServiceChargeAssignTo || {});
var ServiceChargeDiscount = /* @__PURE__ */ ((ServiceChargeDiscount2) => {
  ServiceChargeDiscount2["PRE_DISCOUNT"] = "pre discount";
  ServiceChargeDiscount2["POST_DISCOUNT"] = "post discount";
  return ServiceChargeDiscount2;
})(ServiceChargeDiscount || {});
var ServiceChargeType = /* @__PURE__ */ ((ServiceChargeType2) => {
  ServiceChargeType2["FIXED"] = "fixed";
  ServiceChargeType2["PERCENT"] = "percent";
  ServiceChargeType2["CUSTOM_DOLLAR"] = "custom_dollar";
  ServiceChargeType2["CUSTOM_PERCENT"] = "custom_percent";
  return ServiceChargeType2;
})(ServiceChargeType || {});
var TicketSeatBarType = /* @__PURE__ */ ((TicketSeatBarType2) => {
  TicketSeatBarType2["NONE"] = "none";
  TicketSeatBarType2["CAROUSEL"] = "carousel";
  TicketSeatBarType2["BUTTONS_WITH_FILTER"] = "buttonsWithFilter";
  TicketSeatBarType2["BUTTONS_NO_FILTER"] = "buttonsNoFilter";
  return TicketSeatBarType2;
})(TicketSeatBarType || {});
var EDualPricingListPrice = /* @__PURE__ */ ((EDualPricingListPrice2) => {
  EDualPricingListPrice2["CASH"] = "cash";
  EDualPricingListPrice2["CARD"] = "card";
  return EDualPricingListPrice2;
})(EDualPricingListPrice || {});
var ESeatManagementButtonFunction = /* @__PURE__ */ ((ESeatManagementButtonFunction2) => {
  ESeatManagementButtonFunction2["SEAT_TAGS_ONLY"] = "seatTagsOnly";
  ESeatManagementButtonFunction2["ALLOW_PRESELECT_SEATS"] = "allowPreselectSeats";
  return ESeatManagementButtonFunction2;
})(ESeatManagementButtonFunction || {});
var KitchenTicketTextPosition = /* @__PURE__ */ ((KitchenTicketTextPosition2) => {
  KitchenTicketTextPosition2["BEFORE"] = "Before";
  KitchenTicketTextPosition2["AFTER"] = "After";
  return KitchenTicketTextPosition2;
})(KitchenTicketTextPosition || {});
var GuestCheckSortItemsByType = /* @__PURE__ */ ((GuestCheckSortItemsByType2) => {
  GuestCheckSortItemsByType2["REGISTER_COURSE"] = "registerCourse";
  GuestCheckSortItemsByType2["MENU_COURSE"] = "menuCourse";
  GuestCheckSortItemsByType2["TIME_ADDED_TO_TICKET"] = "timeAddedToTicket";
  GuestCheckSortItemsByType2["TIME_SENT_TO_KITCHEN"] = "timeSentToKitchen";
  return GuestCheckSortItemsByType2;
})(GuestCheckSortItemsByType || {});
var GuestCheckSecondSortItemsByType = /* @__PURE__ */ ((GuestCheckSecondSortItemsByType2) => {
  GuestCheckSecondSortItemsByType2["ALPHABETICAL"] = "alphabetical";
  GuestCheckSecondSortItemsByType2["ALPHABETICAL_REVERSE"] = "alphabeticalReverse";
  GuestCheckSecondSortItemsByType2["TIME_ADDED_TO_TICKET"] = "timeAddedToTicket";
  return GuestCheckSecondSortItemsByType2;
})(GuestCheckSecondSortItemsByType || {});
var RoleDefaultModuleType = /* @__PURE__ */ ((RoleDefaultModuleType2) => {
  RoleDefaultModuleType2["REGISTER_MODULE"] = "registerModule";
  RoleDefaultModuleType2["MENU_MODULE"] = "menuModule";
  RoleDefaultModuleType2["SETTINGS_MODULE"] = "settingsModule";
  RoleDefaultModuleType2["MANAGEMENT_MODULE"] = "managementModule";
  RoleDefaultModuleType2["REPORTS_MODULE"] = "reportsModule";
  RoleDefaultModuleType2["HOME_MODULE"] = "homeModule";
  RoleDefaultModuleType2["CUSTOMERS_MODULE"] = "customersModule";
  return RoleDefaultModuleType2;
})(RoleDefaultModuleType || {});
var RoleBehaviorOnNewOrderType = /* @__PURE__ */ ((RoleBehaviorOnNewOrderType2) => {
  RoleBehaviorOnNewOrderType2["ENTER_ORDER"] = "enter_order";
  RoleBehaviorOnNewOrderType2["STAY_IN_TABLE_LAYOUT"] = "stay_in_table_layout";
  return RoleBehaviorOnNewOrderType2;
})(RoleBehaviorOnNewOrderType || {});
var EViewShiftSummary = /* @__PURE__ */ ((EViewShiftSummary2) => {
  EViewShiftSummary2["ALWAYS"] = "always";
  EViewShiftSummary2["NEVER"] = "never";
  EViewShiftSummary2["ON_CLOCKOUT"] = "onClockout";
  return EViewShiftSummary2;
})(EViewShiftSummary || {});
var ERegisterScreenPermissions = /* @__PURE__ */ ((ERegisterScreenPermissions2) => {
  ERegisterScreenPermissions2["createOrders"] = "createOrders";
  ERegisterScreenPermissions2["deleteOrders"] = "deleteOrders";
  ERegisterScreenPermissions2["voidIndividualItems"] = "voidIndividualItems";
  ERegisterScreenPermissions2["modifyItemsSentToKitchen"] = "modifyItemsSentToKitchen";
  ERegisterScreenPermissions2["editOtherUsersOrders"] = "editOtherUsersOrders";
  ERegisterScreenPermissions2["transferOrderOwner"] = "transferOrderOwner";
  ERegisterScreenPermissions2["manageTables"] = "manageTables";
  ERegisterScreenPermissions2["addAnyDiscount"] = "addAnyDiscount";
  ERegisterScreenPermissions2["addCustomDiscount"] = "addCustomDiscount";
  ERegisterScreenPermissions2["overrideLicenseEditingId"] = "overrideLicenseEditingId";
  ERegisterScreenPermissions2["allowChangeMenuType"] = "allowChangeMenuType";
  ERegisterScreenPermissions2["editItemPrice"] = "editItemPrice";
  ERegisterScreenPermissions2["allow86"] = "allow86";
  ERegisterScreenPermissions2["createPayments"] = "createPayments";
  ERegisterScreenPermissions2["createChecks"] = "createChecks";
  ERegisterScreenPermissions2["voidRefundPayments"] = "voidRefundPayments";
  ERegisterScreenPermissions2["batch"] = "batch";
  ERegisterScreenPermissions2["reprint"] = "reprint";
  ERegisterScreenPermissions2["deletePrintJobs"] = "deletePrintJobs";
  ERegisterScreenPermissions2["manageDrawers"] = "manageDrawers";
  ERegisterScreenPermissions2["reopenClosedOrders"] = "reopenClosedOrders";
  ERegisterScreenPermissions2["transferPayments"] = "transferPayments";
  ERegisterScreenPermissions2["viewDrawerBalance"] = "viewDrawerBalance";
  ERegisterScreenPermissions2["serverBankEnabled"] = "serverBankEnabled";
  ERegisterScreenPermissions2["allowCashPaymentsToDrawersNotAttached"] = "allowCashPaymentsToDrawersNotAttached";
  ERegisterScreenPermissions2["createOpenItemsOrModItems"] = "createOpenItemsOrModItems";
  ERegisterScreenPermissions2["exemptTax"] = "exemptTax";
  ERegisterScreenPermissions2["manageServiceCharges"] = "manageServiceCharges";
  ERegisterScreenPermissions2["viewPrinterCenter"] = "viewPrinterCenter";
  ERegisterScreenPermissions2["changePrinterStatus"] = "changePrinterStatus";
  ERegisterScreenPermissions2["transferPrintJobs"] = "transferPrintJobs";
  ERegisterScreenPermissions2["reAssignBackupPrinter"] = "reAssignBackupPrinter";
  ERegisterScreenPermissions2["reprintClosedCheck"] = "reprintClosedCheck";
  ERegisterScreenPermissions2["reprintReceipt"] = "reprintReceipt";
  ERegisterScreenPermissions2["refundTypeRefund"] = "refundTypeRefund";
  ERegisterScreenPermissions2["refundTypeAsDiscount"] = "refundTypeAsDiscount";
  ERegisterScreenPermissions2["refundTypeToBalanceDueOfZero"] = "refundTypeToBalanceDueOfZero";
  ERegisterScreenPermissions2["refundTypeReplacePayment"] = "refundTypeReplacePayment";
  ERegisterScreenPermissions2["allowNoTaxInclusive"] = "allowNoTaxInclusive";
  return ERegisterScreenPermissions2;
})(ERegisterScreenPermissions || {});
var ERegisterCashPaymentOptions = /* @__PURE__ */ ((ERegisterCashPaymentOptions2) => {
  ERegisterCashPaymentOptions2["PAY_TO_DRAWER_ONLY"] = "Pay to Drawer Only";
  ERegisterCashPaymentOptions2["PAY_TO_SERVER_BANK_ONLY"] = "Pay to Server Bank Only";
  return ERegisterCashPaymentOptions2;
})(ERegisterCashPaymentOptions || {});
var SettingsTypes = /* @__PURE__ */ ((SettingsTypes2) => {
  SettingsTypes2["MASTER_SETTINGS"] = "master";
  SettingsTypes2["LOCATION_SETTINGS"] = "location";
  SettingsTypes2["REMOTE_LOCATION_SETTINGS"] = "remoteLocation";
  return SettingsTypes2;
})(SettingsTypes || {});
var CustomizerPartition = /* @__PURE__ */ ((CustomizerPartition2) => {
  CustomizerPartition2["HALVES"] = "halves";
  CustomizerPartition2["QUARTERS"] = "quarters";
  return CustomizerPartition2;
})(CustomizerPartition || {});
var CustomizerShape = /* @__PURE__ */ ((CustomizerShape2) => {
  CustomizerShape2["SQUARE"] = "square";
  CustomizerShape2["CIRCLE"] = "circle";
  return CustomizerShape2;
})(CustomizerShape || {});
var ModifierTagPositions = /* @__PURE__ */ ((ModifierTagPositions2) => {
  ModifierTagPositions2["BEFORE"] = "before";
  ModifierTagPositions2["AFTER"] = "after";
  return ModifierTagPositions2;
})(ModifierTagPositions || {});
var NavigationActionOnSendType = /* @__PURE__ */ ((NavigationActionOnSendType2) => {
  NavigationActionOnSendType2["LOGOUT"] = "Logout";
  NavigationActionOnSendType2["VIEW_TABLES"] = "View Tables";
  NavigationActionOnSendType2["VIEW_TABS"] = "View Tabs";
  NavigationActionOnSendType2["VIEW_ORDERS"] = "View Orders";
  NavigationActionOnSendType2["NEW_ORDER"] = "New Order";
  NavigationActionOnSendType2["CLEAR_REGISTER"] = "Clear Register";
  NavigationActionOnSendType2["STAY_IN_ORDER"] = "Stay In Order";
  return NavigationActionOnSendType2;
})(NavigationActionOnSendType || {});
var NavigationActionOnPrintCheck = /* @__PURE__ */ ((NavigationActionOnPrintCheck2) => {
  NavigationActionOnPrintCheck2["SEND_AND_LOGOUT"] = "Send And Logout";
  NavigationActionOnPrintCheck2["SEND_AND_VIEW_TABLES"] = "Send And View Tables";
  NavigationActionOnPrintCheck2["SEND_AND_VIEW_TABS"] = "Send And View Tabs";
  NavigationActionOnPrintCheck2["SEND_AND_VIEW_ORDERS"] = "Send And View Orders";
  NavigationActionOnPrintCheck2["SEND_AND_CLEAR_REGISTER"] = "Send And Clear Register";
  NavigationActionOnPrintCheck2["SEND"] = "Send";
  NavigationActionOnPrintCheck2["NONE"] = "None";
  return NavigationActionOnPrintCheck2;
})(NavigationActionOnPrintCheck || {});
var SendOrderToKitchenType = /* @__PURE__ */ ((SendOrderToKitchenType2) => {
  SendOrderToKitchenType2["PAYMENT_INITIATED"] = "Payment Initiated";
  SendOrderToKitchenType2["PAYMENT_COMPLETED"] = "Payment Completed";
  return SendOrderToKitchenType2;
})(SendOrderToKitchenType || {});
var QsrActionOnPayType = /* @__PURE__ */ ((QsrActionOnPayType2) => {
  QsrActionOnPayType2["LOGOUT"] = "logout";
  QsrActionOnPayType2["NEW_ORDER"] = "new order";
  QsrActionOnPayType2["VIEW_ORDERS"] = "view orders";
  return QsrActionOnPayType2;
})(QsrActionOnPayType || {});
var DefaultOrderTypeType = /* @__PURE__ */ ((DefaultOrderTypeType2) => {
  DefaultOrderTypeType2["DINE_IN"] = "dine in";
  DefaultOrderTypeType2["TO_GO"] = "to_go";
  return DefaultOrderTypeType2;
})(DefaultOrderTypeType || {});
var QsrSendAndPayActionButtonsType = /* @__PURE__ */ ((QsrSendAndPayActionButtonsType2) => {
  QsrSendAndPayActionButtonsType2["PAY_ONLY"] = "pay_only";
  QsrSendAndPayActionButtonsType2["SEND_ONLY"] = "send_only";
  QsrSendAndPayActionButtonsType2["BOTH"] = "both";
  return QsrSendAndPayActionButtonsType2;
})(QsrSendAndPayActionButtonsType || {});
var DEFAULT_SPECIAL_TAG_COLOR = "darkGreen";
var DEFAULT_SPECIAL_TAG_TEXT_COLOR = "textWhite";
var DEFAULT_ORDER_SEAT_TAG_COLOR = "cardWhite";
var DEFAULT_ORDER_SEAT_TAG_TEXT_COLOR = "black";
var OrderSeatTagType = /* @__PURE__ */ ((OrderSeatTagType2) => {
  OrderSeatTagType2["ALLERGY"] = "allergy";
  OrderSeatTagType2["ATTRIBUTE"] = "attribute";
  OrderSeatTagType2["MILESTONE"] = "milestone";
  return OrderSeatTagType2;
})(OrderSeatTagType || {});
var DayOfWeek = /* @__PURE__ */ ((DayOfWeek2) => {
  DayOfWeek2["MONDAY"] = "monday";
  DayOfWeek2["TUESDAY"] = "tuesday";
  DayOfWeek2["WEDNESDAY"] = "wednesday";
  DayOfWeek2["THURSDAY"] = "thursday";
  DayOfWeek2["FRIDAY"] = "friday";
  DayOfWeek2["SATURDAY"] = "saturday";
  DayOfWeek2["SUNDAY"] = "sunday";
  return DayOfWeek2;
})(DayOfWeek || {});
var DayOfWeekAbbreviated = /* @__PURE__ */ ((DayOfWeekAbbreviated2) => {
  DayOfWeekAbbreviated2["MONDAY"] = "Mo";
  DayOfWeekAbbreviated2["TUESDAY"] = "Tu";
  DayOfWeekAbbreviated2["WEDNESDAY"] = "We";
  DayOfWeekAbbreviated2["THURSDAY"] = "Th";
  DayOfWeekAbbreviated2["FRIDAY"] = "Fr";
  DayOfWeekAbbreviated2["SATURDAY"] = "Sa";
  DayOfWeekAbbreviated2["SUNDAY"] = "Su";
  return DayOfWeekAbbreviated2;
})(DayOfWeekAbbreviated || {});
var KitchenPrinterColor = /* @__PURE__ */ ((KitchenPrinterColor2) => {
  KitchenPrinterColor2["NEGATIVE"] = "negative";
  KitchenPrinterColor2["BLACK"] = "black";
  return KitchenPrinterColor2;
})(KitchenPrinterColor || {});
var KitchenHeaderBlankSpace = /* @__PURE__ */ ((KitchenHeaderBlankSpace2) => {
  KitchenHeaderBlankSpace2["ZERO"] = "0";
  KitchenHeaderBlankSpace2["ZERO_TWO_FIVE"] = "0.25";
  KitchenHeaderBlankSpace2["ZERO_FIVE"] = "0.5";
  KitchenHeaderBlankSpace2["ZERO_SEVEN_FIVE"] = "0.75";
  KitchenHeaderBlankSpace2["ONE"] = "1.00";
  KitchenHeaderBlankSpace2["ONE_TWO_FIVE"] = "1.25";
  KitchenHeaderBlankSpace2["ONE_FIVE"] = "1.5";
  KitchenHeaderBlankSpace2["ONE_SEVEN_FIVE"] = "1.75";
  KitchenHeaderBlankSpace2["TWO"] = "2.0";
  return KitchenHeaderBlankSpace2;
})(KitchenHeaderBlankSpace || {});
var KitchenElementSpacing = /* @__PURE__ */ ((KitchenElementSpacing2) => {
  KitchenElementSpacing2["ZERO"] = "0";
  KitchenElementSpacing2["ZERO_ZERO_TWO"] = "0.02";
  KitchenElementSpacing2["ZERO_ZERO_FIVE"] = "0.05";
  KitchenElementSpacing2["ZERO_ONE"] = "0.1";
  KitchenElementSpacing2["ZERO_ONE_FIVE"] = "0.15";
  KitchenElementSpacing2["ZERO_TWO"] = "0.2";
  KitchenElementSpacing2["ZERO_TWO_FIVE"] = "0.25";
  return KitchenElementSpacing2;
})(KitchenElementSpacing || {});
var KitchenTicketJustify = /* @__PURE__ */ ((KitchenTicketJustify2) => {
  KitchenTicketJustify2["LEFT"] = "left";
  KitchenTicketJustify2["CENTER"] = "center";
  KitchenTicketJustify2["RIGHT"] = "right";
  return KitchenTicketJustify2;
})(KitchenTicketJustify || {});
var KitchenTicketFontWeight = /* @__PURE__ */ ((KitchenTicketFontWeight2) => {
  KitchenTicketFontWeight2["NORMAL"] = "normal";
  KitchenTicketFontWeight2["BOLD"] = "bold";
  return KitchenTicketFontWeight2;
})(KitchenTicketFontWeight || {});
var KitchenTicketLine = /* @__PURE__ */ ((KitchenTicketLine2) => {
  KitchenTicketLine2["NONE"] = "none";
  KitchenTicketLine2["ABOVE"] = "above";
  KitchenTicketLine2["BELOW"] = "below";
  return KitchenTicketLine2;
})(KitchenTicketLine || {});
var ModifierItemDisplayModes = /* @__PURE__ */ ((ModifierItemDisplayModes2) => {
  ModifierItemDisplayModes2["COMMA"] = "comma";
  ModifierItemDisplayModes2["VERTICAL"] = "vertical";
  return ModifierItemDisplayModes2;
})(ModifierItemDisplayModes || {});
var ClockInModes = /* @__PURE__ */ ((ClockInModes2) => {
  ClockInModes2["MANUAL"] = "manual";
  ClockInModes2["PROMPT"] = "prompt";
  ClockInModes2["AUTO"] = "auto";
  return ClockInModes2;
})(ClockInModes || {});
var SET_LOCKSCREEN_SETTINGS = "SET_LOCKSCREEN_SETTINGS";
var SET_ROLES = "SET_ROLES";
var SET_GENERAL_SETTINGS = "SET_GENERAL_SETTINGS";
var SET_REGISTER_SETTINGS = "SET_REGISTER_SETTINGS";
var SET_REGISTER_TICKET_SETTINGS = "SET_REGISTER_TICKET_SETTINGS";
var SET_SELECTED_SETTINGS_MODE = "SET_SELECTED_SETTINGS_MODE";
var SET_SELECTED_SETTINGS_MODE_WS = "SET_SELECTED_SETTINGS_MODE_WS";

export { ClockInModes, CoursingModes, CustomizerPartition, CustomizerShape, DEFAULT_ORDER_SEAT_TAG_COLOR, DEFAULT_ORDER_SEAT_TAG_TEXT_COLOR, DEFAULT_SPECIAL_TAG_COLOR, DEFAULT_SPECIAL_TAG_TEXT_COLOR, DayOfWeek, DayOfWeekAbbreviated, DefaultOrderTypeType, DefaultTipInput, EDualPricingListPrice, EPinPadLayouts, ERegisterCashPaymentOptions, ERegisterScreenPermissions, ESeatManagementButtonFunction, EViewShiftSummary, GuestCheckSecondSortItemsByType, GuestCheckSortItemsByType, KitchenCustomizingReceiptsStatus, KitchenElementSpacing, KitchenHeaderBlankSpace, KitchenPrinterColor, KitchenTicketFontWeight, KitchenTicketJustify, KitchenTicketLine, KitchenTicketTextPosition, ModifierItemDisplayModes, ModifierTagPositions, NavigationActionOnPrintCheck, NavigationActionOnSendType, OrderSeatTagType, QsrActionOnPayType, QsrSendAndPayActionButtonsType, RegisterSeatingModes, RoleBehaviorOnNewOrderType, RoleDefaultModuleType, SET_GENERAL_SETTINGS, SET_LOCKSCREEN_SETTINGS, SET_REGISTER_SETTINGS, SET_REGISTER_TICKET_SETTINGS, SET_ROLES, SET_SELECTED_SETTINGS_MODE, SET_SELECTED_SETTINGS_MODE_WS, SendOrderToKitchenType, ServiceChargeAssignTo, ServiceChargeDiscount, ServiceChargeType, SettingsTypes, SplitTipInterval, TicketSeatBarType, TipDistribution, TipPayoutMethods, TipShareBy };
